import { StyleSheet, Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: (isDefault, isSelected, theme) => ({
    width: isDefault ? '100%' : 220,
    alignSelf: isDefault ? 'center' : 'flex-start',
    height: isDefault ? 70 : 90,
    marginRight: isDefault ? 0 : 10,
    borderRadius: 6.2,
    borderColor: isDefault || isSelected ? theme.colors.activeColorThree : Colors.brownGrey,
    borderWidth: isDefault || isSelected ? 2.1 : 1,
    marginBottom: 17,
  }),
  card: isDefault => ({
    padding: 10,
    paddingTop: 15,
    flexDirection: isDefault ? 'row' : 'column',
    alignItems: isDefault ? 'center' : 'flex-start',
    paddingHorizontal: 16,
  }),
  expiryText: theme => ({
    flex: 1,
    alignSelf: 'flex-end',
    textAlign: 'right',
    marginBottom: -2,
    color: theme.colors.subtitle,
  }),
  cardNumber: theme => ({
    fontSize: 14,
    lineHeight: 18,
    color: theme.colors.textColorTwo,
  }),
  iconImage: isDefault => ({
    width: isDefault ? 50 : 40,
    height: isDefault ? 33 : 26.7,
    maxHeight: 30,
    maxWidth: 80,
    marginRight: isDefault ? 16 : 0,
    marginBottom: 14.7,
  }),
  cardName: (isSelected, theme) => ({
    lineHeight: 28,
    color: theme.colors.headerColor,
    marginTop: isSelected ? 2 : 6,
    fontSize: Platform.OS === 'ios' ? 18.7 : 18,
    fontWeight: isSelected ? 'bold' : 'normal',
  }),
});
